import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { MultilingualDropdownInterface, MultilingualDropdownModel } from '../../models/multilingual.model';

@Injectable({
    providedIn: 'root',
})
export class MultilingualService {
    // BehaviorSubject storing array of available languages from API
    public availableLanguage: BehaviorSubject<MultilingualDropdownModel[]> = new BehaviorSubject<
        MultilingualDropdownModel[]
    >([]);
    
    // BehaviorSubject storing current language from API
    public currentLanguage: BehaviorSubject<string> = new BehaviorSubject<string>('');

    private apiRoute = `${ENVIRONMENT.apiDomain}/api/v1/multilingual`;

    constructor(private httpClient: HttpClient) {}

    public getMultilingualDropdown(): Observable<ApiResponse<MultilingualDropdownInterface[]>> {
        return this.httpClient.get<ApiResponse<MultilingualDropdownInterface[]>>(`${this.apiRoute}/dropdown`);
    }
}
